/*
 * Copyright 2026 Jason Figge
 *
 * This file is part of Chip Hippo.
 *
 * Chip Hippo is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or (at your option)
 * any later version.
 *
 * Chip Hippo is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Chip Hippo. If not, see <https://www.gnu.org/licenses/>.
 */

// digital-lib.js — GENERATED by scripts/extract-digital-pins.mjs from the
// Digital simulator's DIL chip library (hneemann/Digital, GPL-3.0). Do not
// edit by hand: re-run the script against a Digital release instead.
//
// Per library file: its `Width` attribute (which places the right-hand pin
// column), its pin count, which pins are OUTPUTS, and each pin's label —
// the geometry model/export/digital.js draws to, and the table
// tests/export-digital.test.js holds our catalog's pin numbers against.

export const DIGITAL_LIB = Object.freeze({
  "7400.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 6, 8, 11],
    names: {
      1: "1A",
      2: "1B",
      3: "1Y",
      4: "2A",
      5: "2B",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "4Y",
      12: "4A",
      13: "4B",
      14: "VCC",
    },
  },
  "7401.dig": {
    width: 5,
    pins: 14,
    outputs: [1, 4, 10, 13],
    names: {
      1: "1Y",
      2: "1A",
      3: "1B",
      4: "2Y",
      5: "2A",
      6: "2B",
      7: "GND",
      8: "3A",
      9: "3B",
      10: "3Y",
      11: "4A",
      12: "4B",
      13: "4Y",
      14: "VCC",
    },
  },
  "7402.dig": {
    width: 5,
    pins: 14,
    outputs: [1, 4, 10, 13],
    names: {
      1: "1Y",
      2: "1A",
      3: "1B",
      4: "2Y",
      5: "2A",
      6: "2B",
      7: "GND",
      8: "3A",
      9: "3B",
      10: "3Y",
      11: "4A",
      12: "4B",
      13: "4Y",
      14: "VCC",
    },
  },
  "7403.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 6, 8, 11],
    names: {
      1: "1A",
      2: "1B",
      3: "1Y",
      4: "2A",
      5: "2B",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "4Y",
      12: "4A",
      13: "4B",
      14: "VCC",
    },
  },
  "7404.dig": {
    width: 5,
    pins: 14,
    outputs: [2, 4, 6, 8, 10, 12],
    names: {
      1: "1A",
      2: "1Y",
      3: "2A",
      4: "2Y",
      5: "3A",
      6: "3Y",
      7: "GND",
      8: "4Y",
      9: "4A",
      10: "5Y",
      11: "5A",
      12: "6Y",
      13: "6A",
      14: "VCC",
    },
  },
  "7405.dig": {
    width: 5,
    pins: 14,
    outputs: [2, 4, 6, 8, 10, 12],
    names: {
      1: "1A",
      2: "1Y",
      3: "2A",
      4: "2Y",
      5: "3A",
      6: "3Y",
      7: "GND",
      8: "4Y",
      9: "4A",
      10: "5Y",
      11: "5A",
      12: "6Y",
      13: "6A",
      14: "VCC",
    },
  },
  "7408.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 6, 8, 11],
    names: {
      1: "1A",
      2: "1B",
      3: "1Y",
      4: "2A",
      5: "2B",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "4Y",
      12: "4A",
      13: "4B",
      14: "VCC",
    },
  },
  "7410.dig": {
    width: 5,
    pins: 14,
    outputs: [6, 8, 12],
    names: {
      1: "1A",
      2: "1B",
      3: "2A",
      4: "2B",
      5: "2C",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "3C",
      12: "1Y",
      13: "1C",
      14: "VCC",
    },
  },
  "74107.dig": {
    width: 5,
    pins: 14,
    outputs: [2, 3, 5, 6],
    names: {
      1: "1J",
      2: "1~Q",
      3: "1Q",
      4: "1K",
      5: "2Q",
      6: "2~Q",
      7: "GND",
      8: "2J",
      9: "2~CLK",
      10: "2~C",
      11: "2K",
      12: "1~CLK",
      13: "1~C",
      14: "VCC",
    },
  },
  "7411.dig": {
    width: 5,
    pins: 14,
    outputs: [6, 8, 12],
    names: {
      1: "1A",
      2: "1B",
      3: "2A",
      4: "2B",
      5: "2C",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "3C",
      12: "1Y",
      13: "1C",
      14: "VCC",
    },
  },
  "74112.dig": {
    width: 5,
    pins: 16,
    outputs: [5, 6, 7, 9],
    names: {
      1: "~1CK",
      2: "1K",
      3: "1J",
      4: "~1PR",
      5: "1Q",
      6: "~1Q",
      7: "~2Q",
      8: "GND",
      9: "2Q",
      10: "~2PR",
      11: "2J",
      12: "2K",
      13: "~2CK",
      14: "~2CLR",
      15: "~1CLR",
      16: "VCC",
    },
  },
  "74125.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 6, 8, 11],
    names: {
      1: "~G1",
      2: "A1",
      3: "Y1",
      4: "~G2",
      5: "A2",
      6: "Y2",
      7: "GND",
      8: "Y3",
      9: "A3",
      10: "~G3",
      11: "Y4",
      12: "A4",
      13: "~G4",
      14: "VCC",
    },
  },
  "74138.dig": {
    width: 5,
    pins: 16,
    outputs: [7, 9, 10, 11, 12, 13, 14, 15],
    names: {
      1: "A",
      2: "B",
      3: "C",
      4: "~GA",
      5: "~GB",
      6: "G",
      7: "~Y7",
      8: "GND",
      9: "~Y6",
      10: "~Y5",
      11: "~Y4",
      12: "~Y3",
      13: "~Y2",
      14: "~Y1",
      15: "~Y0",
      16: "VCC",
    },
  },
  "74139.dig": {
    width: 5,
    pins: 16,
    outputs: [4, 5, 6, 7, 9, 10, 11, 12],
    names: {
      1: "~1G",
      2: "1A",
      3: "1B",
      4: "~1Y0",
      5: "~1Y1",
      6: "~1Y2",
      7: "~1Y3",
      8: "GND",
      9: "~2Y3",
      10: "~2Y2",
      11: "~2Y1",
      12: "~2Y0",
      13: "2B",
      14: "2A",
      15: "~2G",
      16: "VCC",
    },
  },
  "7414.dig": {
    width: 5,
    pins: 14,
    outputs: [2, 4, 6, 8, 10, 12],
    names: {
      1: "1A",
      2: "1Y",
      3: "2A",
      4: "2Y",
      5: "3A",
      6: "3Y",
      7: "GND",
      8: "4Y",
      9: "4A",
      10: "5Y",
      11: "5A",
      12: "6Y",
      13: "6A",
      14: "VCC",
    },
  },
  "74148.dig": {
    width: 5,
    pins: 16,
    outputs: [6, 7, 9, 14, 15],
    names: {
      1: "4",
      2: "5",
      3: "6",
      4: "7",
      5: "EI",
      6: "A2",
      7: "A1",
      8: "GND",
      9: "A0",
      10: "0",
      11: "1",
      12: "2",
      13: "3",
      14: "GS",
      15: "E0",
      16: "VCC",
    },
  },
  "74151.dig": {
    width: 5,
    pins: 16,
    outputs: [5, 6],
    names: {
      1: "D3",
      2: "D2",
      3: "D1",
      4: "D0",
      5: "Y",
      6: "W",
      7: "S",
      8: "GND",
      9: "C",
      10: "B",
      11: "A",
      12: "D7",
      13: "D6",
      14: "D5",
      15: "D4",
      16: "VCC",
    },
  },
  "74153.dig": {
    width: 5,
    pins: 16,
    outputs: [7, 9],
    names: {
      1: "1G",
      2: "B",
      3: "1C3",
      4: "1C2",
      5: "1C1",
      6: "1C0",
      7: "1Y",
      8: "GND",
      9: "2Y",
      10: "2C0",
      11: "2C1",
      12: "2C2",
      13: "2C3",
      14: "A",
      15: "2G",
      16: "VCC",
    },
  },
  "74157.dig": {
    width: 5,
    pins: 16,
    outputs: [4, 7, 9, 12],
    names: {
      1: "S",
      2: "A1",
      3: "B1",
      4: "Y1",
      5: "A2",
      6: "B2",
      7: "Y2",
      8: "GND",
      9: "Y3",
      10: "B3",
      11: "A3",
      12: "Y4",
      13: "B4",
      14: "A4",
      15: "G",
      16: "VCC",
    },
  },
  "74161.dig": {
    width: 5,
    pins: 16,
    outputs: [11, 12, 13, 14, 15],
    names: {
      1: "~CLR",
      2: "CLK",
      3: "A",
      4: "B",
      5: "C",
      6: "D",
      7: "ENP",
      8: "GND",
      9: "~LD",
      10: "ENT",
      11: "QD",
      12: "QC",
      13: "QB",
      14: "QA",
      15: "RCO",
      16: "VCC",
    },
  },
  "74164.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 4, 5, 6, 10, 11, 12, 13],
    names: {
      1: "DSA",
      2: "DSB",
      3: "Q0",
      4: "Q1",
      5: "Q2",
      6: "Q3",
      7: "GND",
      8: "CP",
      9: "~MR",
      10: "Q4",
      11: "Q5",
      12: "Q6",
      13: "Q7",
      14: "VCC",
    },
  },
  "74165.dig": {
    width: 5,
    pins: 16,
    outputs: [7, 9],
    names: {
      1: "~LD",
      2: "CLK",
      3: "E",
      4: "F",
      5: "G",
      6: "H",
      7: "~QH",
      8: "GND",
      9: "QH",
      10: "SER",
      11: "A",
      12: "B",
      13: "C",
      14: "D",
      15: "INH",
      16: "VCC",
    },
  },
  "74173.dig": {
    width: 5,
    pins: 16,
    outputs: [3, 4, 5, 6],
    names: {
      1: "OE1",
      2: "OE2",
      3: "Q0",
      4: "Q1",
      5: "Q2",
      6: "Q3",
      7: "CLK",
      8: "GND",
      9: "DE1",
      10: "DE2",
      11: "D3",
      12: "D2",
      13: "D1",
      14: "D0",
      15: "RES",
      16: "VCC",
    },
  },
  "74174.dig": {
    width: 5,
    pins: 16,
    outputs: [2, 5, 7, 10, 12, 15],
    names: {
      1: "~CL",
      2: "Q1",
      3: "D1",
      4: "D2",
      5: "Q2",
      6: "D3",
      7: "Q3",
      8: "GND",
      9: "CLK",
      10: "Q4",
      11: "D4",
      12: "Q5",
      13: "D5",
      14: "D6",
      15: "Q6",
      16: "VCC",
    },
  },
  "74175.dig": {
    width: 5,
    pins: 16,
    outputs: [2, 3, 6, 7, 10, 11, 14, 15],
    names: {
      1: "~CL",
      2: "Q1",
      3: "~Q1",
      4: "D1",
      5: "D2",
      6: "~Q2",
      7: "Q2",
      8: "GND",
      9: "CLK",
      10: "Q3",
      11: "~Q3",
      12: "D3",
      13: "D4",
      14: "~Q4",
      15: "Q4",
      16: "VCC",
    },
  },
  "74181.dig": {
    width: 11,
    pins: 24,
    outputs: [9, 10, 11, 13, 14, 15, 16, 17],
    names: {
      1: "~B0",
      2: "~A0",
      3: "S3",
      4: "S2",
      5: "S1",
      6: "S0",
      7: "Cn",
      8: "M",
      9: "~F0",
      10: "~F1",
      11: "~F2",
      12: "GND",
      13: "~F3",
      14: "A=B",
      15: "~P",
      16: "Cn+4",
      17: "~G",
      18: "~B3",
      19: "~A3",
      20: "~B2",
      21: "~A2",
      22: "~B1",
      23: "~A1",
      24: "VCC",
    },
  },
  "74193.dig": {
    width: 7,
    pins: 16,
    outputs: [2, 3, 6, 7, 12, 13],
    names: {
      1: "D1",
      2: "Q1",
      3: "Q0",
      4: "DN",
      5: "UP",
      6: "Q2",
      7: "Q3",
      8: "GND",
      9: "D3",
      10: "D2",
      11: "~LD",
      12: "~CO",
      13: "~BO",
      14: "CLR",
      15: "D0",
      16: "VCC",
    },
  },
  "7420.dig": {
    width: 5,
    pins: 14,
    outputs: [6, 8],
    names: {
      1: "1A",
      2: "1B",
      4: "1C",
      5: "1D",
      6: "1Y",
      7: "GND",
      8: "2Y",
      9: "2A",
      10: "2B",
      12: "2C",
      13: "2D",
      14: "VCC",
    },
  },
  "74244.dig": {
    width: 5,
    pins: 20,
    outputs: [3, 5, 7, 9, 12, 14, 16, 18],
    names: {
      1: "1~G",
      2: "1A1",
      3: "2Y4",
      4: "1A2",
      5: "2Y3",
      6: "1A3",
      7: "2Y2",
      8: "1A4",
      9: "2Y1",
      10: "GND",
      11: "2A1",
      12: "1Y4",
      13: "2A2",
      14: "1Y3",
      15: "2A3",
      16: "1Y2",
      17: "2A4",
      18: "1Y1",
      19: "2~G",
      20: "VCC",
    },
  },
  "74245.dig": {
    width: 5,
    pins: 20,
    outputs: [],
    names: {
      1: "DIR",
      2: "A1",
      3: "A2",
      4: "A3",
      5: "A4",
      6: "A5",
      7: "A6",
      8: "A7",
      9: "A8",
      10: "GND",
      11: "B8",
      12: "B7",
      13: "B6",
      14: "B5",
      15: "B4",
      16: "B3",
      17: "B2",
      18: "B1",
      19: "~OE",
      20: "VCC",
    },
  },
  "74257.dig": {
    width: 5,
    pins: 16,
    outputs: [4, 7, 9, 12],
    names: {
      1: "S",
      2: "A1",
      3: "B1",
      4: "Y1",
      5: "A2",
      6: "B2",
      7: "Y2",
      8: "GND",
      9: "Y3",
      10: "B3",
      11: "A3",
      12: "Y4",
      13: "B4",
      14: "A4",
      15: "~G",
      16: "VCC",
    },
  },
  "7427.dig": {
    width: 5,
    pins: 14,
    outputs: [6, 8, 12],
    names: {
      1: "1A",
      2: "1B",
      3: "2A",
      4: "2B",
      5: "2C",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "3C",
      12: "1Y",
      13: "1C",
      14: "VCC",
    },
  },
  "74273.dig": {
    width: 5,
    pins: 20,
    outputs: [2, 5, 6, 9, 12, 15, 16, 19],
    names: {
      1: "~MR",
      2: "Q0",
      3: "D0",
      4: "D1",
      5: "Q1",
      6: "Q2",
      7: "D2",
      8: "D3",
      9: "Q3",
      10: "GND",
      11: "CP",
      12: "Q4",
      13: "D4",
      14: "D5",
      15: "Q5",
      16: "Q6",
      17: "D6",
      18: "D7",
      19: "Q7",
      20: "VCC",
    },
  },
  "74283.dig": {
    width: 5,
    pins: 16,
    outputs: [1, 4, 9, 10, 13],
    names: {
      1: "S2",
      2: "B2",
      3: "A2",
      4: "S1",
      5: "A1",
      6: "B1",
      7: "C0",
      8: "GND",
      9: "C4",
      10: "S4",
      11: "B4",
      12: "A4",
      13: "S3",
      14: "A3",
      15: "B3",
      16: "VCC",
    },
  },
  "7430.dig": {
    width: 5,
    pins: 14,
    outputs: [8],
    names: {
      1: "1A",
      2: "1B",
      3: "1C",
      4: "1D",
      5: "1E",
      6: "1F",
      7: "GND",
      8: "1Y",
      11: "1G",
      12: "1H",
      14: "VCC",
    },
  },
  "7432.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 6, 8, 11],
    names: {
      1: "1A",
      2: "1B",
      3: "1Y",
      4: "2A",
      5: "2B",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "4Y",
      12: "4A",
      13: "4B",
      14: "VCC",
    },
  },
  "744002.dig": {
    width: 5,
    pins: 14,
    outputs: [1, 13],
    names: {
      1: "1Y",
      2: "1A",
      3: "1B",
      4: "1C",
      5: "1D",
      7: "GND",
      9: "2A",
      10: "2B",
      11: "2C",
      12: "2D",
      13: "2Y",
      14: "VCC",
    },
  },
  "744017.dig": {
    width: 5,
    pins: 16,
    outputs: [1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12],
    names: {
      1: "Q5",
      2: "Q1",
      3: "Q0",
      4: "Q2",
      5: "Q6",
      6: "Q7",
      7: "Q3",
      8: "GND",
      9: "Q8",
      10: "Q4",
      11: "Q9",
      12: "~{Q5-9}",
      13: "~CP1",
      14: "CP0",
      15: "MR",
      16: "VCC",
    },
  },
  "744075.dig": {
    width: 5,
    pins: 14,
    outputs: [6, 9, 10],
    names: {
      1: "1A",
      2: "1B",
      3: "2A",
      4: "2B",
      5: "2C",
      6: "2Y",
      7: "GND",
      8: "1C",
      9: "1Y",
      10: "3Y",
      11: "3A",
      12: "3B",
      13: "3C",
      14: "VCC",
    },
  },
  "7447.dig": {
    width: 5,
    pins: 16,
    outputs: [9, 10, 11, 12, 13, 14, 15],
    names: {
      1: "B",
      2: "C",
      3: "~LT",
      4: "~BI/~RBO",
      5: "~RBI",
      6: "D",
      7: "A",
      8: "GND",
      9: "~e",
      10: "~d",
      11: "~c",
      12: "~b",
      13: "~a",
      14: "~g",
      15: "~f",
      16: "VCC",
    },
  },
  "74573.dig": {
    width: 5,
    pins: 20,
    outputs: [12, 13, 14, 15, 16, 17, 18, 19],
    names: {
      1: "~OC",
      2: "D0",
      3: "D1",
      4: "D2",
      5: "D3",
      6: "D4",
      7: "D5",
      8: "D6",
      9: "D7",
      10: "GND",
      11: "C",
      12: "Q7",
      13: "Q6",
      14: "Q5",
      15: "Q4",
      16: "Q3",
      17: "Q2",
      18: "Q1",
      19: "Q0",
      20: "VCC",
    },
  },
  "74595.dig": {
    width: 5,
    pins: 16,
    outputs: [1, 2, 3, 4, 5, 6, 7, 9, 15],
    names: {
      1: "Q_B",
      2: "Q_C",
      3: "Q_D",
      4: "Q_E",
      5: "Q_F",
      6: "Q_G",
      7: "Q_H",
      8: "GND",
      9: "Q_H'",
      10: "~CLR",
      11: "SCLK",
      12: "RCLK",
      13: "~OE",
      14: "SER",
      15: "Q_A",
      16: "VCC",
    },
  },
  "747266.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 4, 10, 11],
    names: {
      1: "1A",
      2: "1B",
      3: "1Y",
      4: "2Y",
      5: "2A",
      6: "2B",
      7: "GND",
      8: "3A",
      9: "3B",
      10: "3Y",
      11: "4Y",
      12: "4A",
      13: "4B",
      14: "VCC",
    },
  },
  "7474.dig": {
    width: 5,
    pins: 14,
    outputs: [5, 6, 8, 9],
    names: {
      1: "~1RD",
      2: "1D",
      3: "1CP",
      4: "~1SD",
      5: "1Q",
      6: "~1Q",
      7: "GND",
      8: "~2Q",
      9: "2Q",
      10: "~2SD",
      11: "2CP",
      12: "2D",
      13: "~2RD",
      14: "VCC",
    },
  },
  "7476.dig": {
    width: 5,
    pins: 16,
    outputs: [10, 11, 14, 15],
    names: {
      1: "1~CLK",
      2: "1~S",
      3: "1~C",
      4: "1J",
      5: "VCC",
      6: "2~CLK",
      7: "2~S",
      8: "2~C",
      9: "2J",
      10: "2~Q",
      11: "2Q",
      12: "2K",
      13: "GND",
      14: "1~Q",
      15: "1Q",
      16: "1K",
    },
  },
  "7483.dig": {
    width: 5,
    pins: 16,
    outputs: [2, 6, 9, 14, 15],
    names: {
      1: "A4",
      2: "S3",
      3: "A3",
      4: "B3",
      5: "VCC",
      6: "S2",
      7: "B2",
      8: "A2",
      9: "S1",
      10: "A1",
      11: "B1",
      12: "GND",
      13: "C0",
      14: "C4",
      15: "S4",
      16: "B4",
    },
  },
  "7485.dig": {
    width: 5,
    pins: 16,
    outputs: [5, 6, 7],
    names: {
      1: "Q_3",
      2: "P<Q_i",
      3: "P=Q_i",
      4: "P>Q_i",
      5: "P>Q",
      6: "P=Q",
      7: "P<Q",
      8: "GND",
      9: "Q_0",
      10: "P_0",
      11: "Q_1",
      12: "P_1",
      13: "P_2",
      14: "Q_2",
      15: "P_3",
      16: "VCC",
    },
  },
  "7486.dig": {
    width: 5,
    pins: 14,
    outputs: [3, 6, 8, 11],
    names: {
      1: "1A",
      2: "1B",
      3: "1Y",
      4: "2A",
      5: "2B",
      6: "2Y",
      7: "GND",
      8: "3Y",
      9: "3A",
      10: "3B",
      11: "4Y",
      12: "4A",
      13: "4B",
      14: "VCC",
    },
  },
  "7490.dig": {
    width: 5,
    pins: 14,
    outputs: [8, 9, 11, 12],
    names: {
      1: "CKB",
      2: "R_0(1)",
      3: "R_0(2)",
      5: "VCC",
      6: "R_9(1)",
      7: "R_9(2)",
      8: "Q_C",
      9: "Q_B",
      10: "GND",
      11: "Q_D",
      12: "Q_A",
      14: "CKA",
    },
  },
});
